<template>
  <div
    v-if="isTimeshiftEnabled"
    v-accessibility-focus="click"
    :aria-label="$t('accessibility.player.liveButton')"
    class="c-player__live"
    :class="{ 'is-live': isLive }"
  >
    <span>LIVE</span>
  </div>
</template>
<script>
  import { setTimeshiftMode, state } from '@/shared/components/player/store';
  import { TimeshiftMode } from '@/shared/components/player/enums';

  export default {
    name: 'UiPlayerLiveButton',
    computed: {
      isLive() {
        return state.timeshiftMode === TimeshiftMode.LIVE;
      },
      isTimeshiftEnabled() {
        return state.timeshiftMode !== TimeshiftMode.DISABLED;
      },
    },
    methods: {
      click() {
        if (!this.isLive) {
          setTimeshiftMode(TimeshiftMode.LIVE);
        }
      },
    },
  };
</script>
